import useSWR from "swr"
import { useSelector } from "react-redux"
import { DeliveryApi } from "../../../apis"
import { IAuth } from "../../../store/Auth"

interface WarehouseRow {
  id: string
  name: string
}

export interface WarehouseOption {
  value: string
  label: string
}

export function useWarehouseOptions() {
  const user = useSelector((state: { auth: IAuth }) => state.auth.user)
  const businessId = user?.currentBusinessId ?? null

  const swr = useSWR(
    businessId ? ["delivery.warehouse-select", businessId] : null,
    async () =>
      (await DeliveryApi.warehouseSelect({
        businessId: businessId as string,
        limit: 100,
      })) as WarehouseRow[],
    { revalidateOnFocus: false },
  )

  const options: WarehouseOption[] = (swr.data ?? []).map((w) => ({
    value: w.id,
    label: w.name,
  }))

  return {
    options,
    isLoading: swr.isLoading,
    error: swr.error as Error | undefined,
    rows: swr.data ?? [],
  }
}
